import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  HeaderList,
  IHeaderListActions,
} from "../../../Components/Header/HeaderList";
import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSButton from "../../../Components/Button/WSButton";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const DoctorService: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, reset, setValue } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const id = params?.id;


   useEffect(()=>{
            updateMainHeader('Doctor Service');
          })

          breadCrumbsStore.updateBreadCrumbs([
                        { 'Doctor Service List': '/doctor-service/list' },
                                          { [!id ? 'Add Doctor Service' : 'Update Doctor Service']: '/doctor-service/create' },
          
                    ]);
          
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getDoctorServiceById(id: any) {
      try {
        const response: any = await callAPI(
          "DoctorService",
          Method.GET,
          {},
          id
        );

        if (response && response?.data) {
          setValue("serviceName", response.data?.serviceName);

          setValue("id", response.data?.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getDoctorServiceById(id);
    }
  }, [id, setValue]);

  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          reset();
        }
      } else if (response?.id) {
        reset();
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };
  const handleData = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          navigate(`/doctor-service/list`);
        }
      } else if (response?.id) {
        showMessage("specialization Created Successfully", "success");
        navigate(`/doctor-service/list`);
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  const saveData = async (data: any) => {
    const request: any = {
      serviceName: data?.serviceName || "",
    };
    if (data?.doctorserviceId) {
      const response: any = await callAPI(
        "DoctorService",
        Method.PUT,
        request,
        data.doctorserviceId
      );
      return response;
    } else {
      const response: any = await callAPI(
        "DoctorService",
        Method.POST,
        request
      );
      return response;
    }
  };

  const handleCancelClick = () => {
    navigate("/doctor-service/list");
  };

  return (
    <Grid p={3}>
      <form onSubmit={handleSubmit(handleData)}>
        
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <WSTextField
                label={"Service Name"}
                {...register("serviceName")}
                id="serviceName"
                name="serviceName"
                control={control}
                rules={{ required: true }}
              />
              <WSHiddenField
                control={control}
                name="doctorserviceId"
                defaultValue={id}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          spacing={2} 
          sx={{ mt: 2 }}
        >
          <Grid item>
            <WSButton
              id="cancel"
              type="button"
              label="Cancel"
              size="medium"
              onClick={handleCancelClick}
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#098963",
                backgroundColor: "#FFFFFF",
              }}
            />
          </Grid>
           {!id &&<Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save & New"
              size="medium"
              variant="outlined"
              color="primary"
              onClick={handleSubmit(handleDataSaveAndNew)}
              loading={loadingSaveAndNew}
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#FFFFFF",
                backgroundColor: "#098963",
                "&:hover": {
                  backgroundColor: "#066e4f",
                },
              }}
            />
          </Grid>}

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#FFFFFF",
                backgroundColor: "#098963",
                "&:hover": {
                  backgroundColor: "#066e4f",
                },
              }}
            />
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
});
